import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { Logo } from 'src/components/logo';

import { useActivePlatform } from 'src/hooks/use-active-platform';
import { NavToggleButton } from 'src/layouts/common';
import { NAV } from 'src/layouts/config-layout';
import { useNavData } from 'src/layouts/dashboard/config-navigation';
import { hideScroll } from 'src/theme/css';

import { TelegramWidget } from '../telegram-widget';
import { NavSectionMini } from './nav-section-mini';

export function SidebarMini() {
  const { userRole } = useActivePlatform();

  const navData = useNavData();

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Logo sx={{ mx: 'auto', my: 2 }} />

        <NavSectionMini
          data={navData}
          slotProps={{
            currentRole: userRole,
          }}
        />

        <Box sx={{ flexGrow: 1 }} />

        <TelegramWidget collapsed />
      </Stack>
    </Box>
  );
}
